
    import { initializeTTSWidget } from './src/index.jsx';
    
    // Wait for DOM to be fully loaded
    document.addEventListener('DOMContentLoaded', function() {
      // Get article content
      const articleContent = document.querySelector('article').textContent;
      
      // Initialize the widget
      const widgetContainer = document.getElementById('tts-widget-container');
      if (widgetContainer) {
        initializeTTSWidget(widgetContainer, {
          content: articleContent,
          autoPlay: false
        });
      }
    });
  